const NftCardOverbid = () => {
  return (
    <div className="tw-absolute tw-right-[-61px] tw-top-[42px] tw-z-10 tw-flex tw-h-7.5 tw-w-[240px] tw-items-center tw-justify-center tw-bg-darkRed [transform:rotate(45deg)]">
      <span className="tw-font-bold tw-uppercase tw-text-white">You were overbid!</span>
    </div>
  );
};

export default NftCardOverbid;
